import { css } from '@emotion/react';

// MEMO: 네이버 에디터 css
// https://editor-static.pstatic.net/v/basic/1.2.1/css/se.viewer.desktop.css
const seCss = `
  .se-viewer {
    .se-text {
      margin-top: 20px;
    }

    .se-text-paragraph {
      word-break: break-word;
      overflow-wrap: break-word;
      white-space: pre-wrap;
    }

    .se-imageStrip-container {
      position: relative;
      white-space: nowrap;
      font-size: 0;
    }

    .se-module-image-link {
      display: block;
    }

    .se-imageStrip {
      .se-module-image:first-of-type {
        margin-left: 0;
      }

      .se-module-image {
        display: inline-block;
        box-sizing: border-box;
        vertical-align: top;
        margin-left: 5px;
      }
    }

    .se-section-imageGroup.se-l-collage {
      .se-module-image:first-of-type {
        margin-left: 0;
      }

      .se-module-image {
        margin-left: 5px;
        display: inline-block;
      }

      .se-imageGroup-item {
        position: relative;
        white-space: nowrap;
        font-size: 0;
      }
    }
  }
`;

const magleStoreCss = `
  #edinfo-studio {
    .edinfo-detail {
      .sp-care-rows {
        .sp-care-row-th {
          padding: 8px 5px 10px !important;
          width: 110px;
          background-color: #f9f9fa !important;
          vertical-align: top !important;
          text-align: right !important;
          font-weight: normal;
        }

        .sp-care-row-td {
          padding: 5px !important;
          position: relative;
        }
      }
      tr {
        .edinfo-name {
          line-height: 22px;
          padding: 0 9px !important;
          height: auto !important;
          white-space: pre-line;
          word-break: normal;
          display: flow-root;
          text-align: right;
        }

        .edinfo-value {
          .edinfo-desc {
            display: block;
            position: relative;
            padding: 2px 5px !important;
            border: 1px solid transparent;
            text-align: left;
            line-height: 22px;
          }
        }
      }
    }
  }
`;

export const defaultCss = css`
  & > div {
    clear: both;
  }

  * {
    font-family: Pretendard JP, Pretendard, sans-serif !important;
    line-height: 160%;
  }

  div {
    max-width: 100% !important;
  }

  video {
    max-width: 100%;
  }

  img {
    display: block;
    max-width: 100% !important;
    width: auto;
    height: auto !important;
    margin: 0 auto;

    &.measurements-guide {
      width: 271px;
      /* 위에 있는 important 때문에 적용 */
      height: 271px !important;
      object-fit: fill;
    }
  }

  blockquote {
    margin: 0;
    padding: 0;
  }

  .extra-field-table {
    font-size: 12px;
    text-align: left;
  }
  .extra-field-table td {
    width: 50%;
  }

  ${seCss}

  ${magleStoreCss}
  
  #edinfo-studio div#edinfo-container .edinfo-sizeimg img {
    margin: auto;
  }

  #edinfo-studio div#edinfo-container .edinfo-sizediv .edinfo-boardSize {
    display: block;
  }
`;
